import * as React from 'react';
import { Form } from 'semantic-ui-react';

import { DineroInput } from 'src/componentes';
import Panel from 'src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Panel';
import { Datos as AlumnosDatos } from '../../S3Alumnos';
import IdentificacionContrato from './IdentificacionContrato';

export interface Props {
    readonly todosLosAlumnos: ReadonlyArray<AlumnosDatos['alumnoPrincipal']>;
    alCambiarMontos(abonoInicial: number, indiceAlumno: number): void;
}

const Arancel = (props: Props) => {
    const { todosLosAlumnos, alCambiarMontos } = props;

    return (
        <Panel titulo='Arancel'>
            {todosLosAlumnos.map((alumno, indiceAlumno) => (
                <Form.Field key={indiceAlumno} width='8'>
                    <label>
                        <IdentificacionContrato alumno={alumno} numero={indiceAlumno + 1} />
                    </label>
                    <DineroInput
                        monto={alumno.montoArancel}
                        alCambiarMonto={monto => alCambiarMontos(monto, indiceAlumno)}
                    />
                </Form.Field>
            ))}

            <Form.Field width='8'>
                <label>Total</label>
                <DineroInput
                    soloLectura
                    monto={todosLosAlumnos.reduce((acc, alu) => acc + alu.montoArancel, 0)}
                />
            </Form.Field>
        </Panel>
    );
};

export default Arancel;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S4Financieros/componentes/Arancel.tsx